var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarmOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alarm_x5F_ON"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.712,4.704l-4.188-2.15l0.394-0.765c0.339-0.66,1.058-0.967,1.604-0.686l2.201,1.131 c0.549,0.282,0.721,1.044,0.381,1.705L18.712,4.704z M20.748,12.236c0,2.939-1.449,5.54-3.672,7.125l1.294,2.801 c0,0,0.055,0.498-0.435,0.738c-0.533,0.263-0.91-0.088-0.91-0.088l-1.272-2.67c-1.138,0.541-2.409,0.844-3.752,0.844 s-2.615-0.303-3.752-0.844l-1.274,2.674c0,0-0.378,0.35-0.911,0.086c-0.488-0.239-0.433-0.737-0.433-0.737l1.294-2.804 c-2.222-1.586-3.673-4.187-3.673-7.125c0-4.833,3.917-8.751,8.749-8.751C16.831,3.485,20.748,7.403,20.748,12.236z M12,5.411 c-3.766,0-6.818,3.055-6.818,6.823S8.234,19.057,12,19.057c3.766,0,6.816-3.056,6.816-6.823C18.816,8.465,15.768,5.411,12,5.411z  M16.422,10.122l-5.132,5.272c-0.443,0.453-0.87,0.174-1.204-0.068l-2.361-2.297c-0.194-0.123-0.321-0.61-0.083-0.982 c0.237-0.372,0.75-0.488,0.943-0.363c0,0,1.682,1.645,1.69,1.636c0.345,0.234,0.672,0.123,0.922-0.121 c1.128-1.099,4.081-4.193,4.081-4.193c0.308-0.316,0.812-0.322,1.131-0.015C16.723,9.299,16.73,9.806,16.422,10.122z M4.876,3.935 c-0.338-0.657-0.168-1.417,0.38-1.697l2.205-1.125c0.548-0.28,1.268,0.026,1.607,0.683L9.46,2.557L5.269,4.695L4.876,3.935z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmOn);
export default __webpack_public_path__ + "static/media/ic_alarm_on.280d2b7b8302d68f93966e9f4e2f1bcf.svg";
export { ForwardRef as ReactComponent };